import $ from 'jquery';
import { scrollToElement } from '../../../utils/scroll-to-element';
import GaTracking from '../../../core/components/ga-tracking';
export default class RatingsAndReviews {
    static interval;
    static init() {
        // @ts-ignore
        window.$ = $;
        this.waitForRatingsToBeInjected();
        this.expandAndScrollToRatingsCommentsOnClick();
        this.addGAEventsOnClick();
        setTimeout(() => {
            this.injectExplanationContent($('.js__ratings-container'));
        }, 2000);
    }
    static waitForRatingsToBeInjected() {
        window.bvCallback = BV => {
            BV.reviews?.on('container_added', (container) => {
                this.interval = setInterval(() => {
                    const $container = $(container);
                    // Periodically checks for child elements to be injected as there is no event from BV to track it.
                    if ($container.find('.bv-cleanslate')) {
                        this.injectExplanationContent($container);
                        window.clearInterval(this.interval);
                    }
                }, 1000);
            });
        };
    }
    static injectExplanationContent($container) {
        if (!$container.find('.js__bv-inline-histogram-ratings-explanation').length &&
            $container.find('.bv-inline-histogram-ratings').length) {
            const $explanationContent = $($container.data('explanation-content'));
            $explanationContent.find('[data-toggle="tooltip"]').tooltip();
            $container.find('.bv-inline-histogram-ratings').append($explanationContent);
        }
    }
    static expandAndScrollToRatingsCommentsOnClick() {
        $('body').on('click', '.js__rating-summary .bv_main_container_row_flex, .bv_modal_outer_content .bv_button_buttonFull', () => {
            const $collapseElement = $('.js__ratings-and-reviews-collapse:not(.show)');
            if ($collapseElement.length) {
                $collapseElement.collapse('show');
                scrollToElement($('.js__ratings-and-reviews-section'), 0);
            }
        });
    }
    static addGAEventsOnClick() {
        $('body').on('click', '.bv_main_rating_button', () => {
            GaTracking.pushDataLayer({
                event: 'custom_market_tracking_datalayer',
                eventAction: 'Click',
                eventCategory: 'PDP',
                eventLabel: 'Review',
                eventNonInteraction: false,
            });
        });
        $('body').on('click', '[class*="bv-questions-filter-"]', () => {
            GaTracking.pushDataLayer({
                event: 'custom_market_tracking_datalayer',
                eventAction: 'Click',
                eventCategory: 'PDP',
                eventLabel: 'Review - filter',
                eventNonInteraction: false,
            });
        });
    }
}
